import { useState } from "react";
import { useParams } from "react-router-dom";

import RoomsGrid from "./RoomsGrid";
import RoomsSkeleton from "./RoomSkeleton";
import RoomsDrawer from "./RoomsDrawer";
import AvailabilityDrawer from "./AvailabilityDrawer";

import useFetch from "../../../clients/features/get_withcredentials";
import axios from "axios";

export default function Rooms({ setActivePage, setNeedRatePlanMsg }) {

  const hotelParams = useParams();
  const hotelId = hotelParams.hotelId;

  const [opened, setOpened] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [availabilityOpen, setAvailabilityOpen] = useState(false);
  const [availabilityRoom, setAvailabilityRoom] = useState(null);

  const { data, loading, refreshData } = useFetch(
    `https://api.komorotel.com/api/rooms/hotel/${hotelId}`
  );

  const openRoom = (room, mode) => {
    if (mode === "availability") {
      setAvailabilityRoom(room);
      setAvailabilityOpen(true);
    } else {
      setSelectedRoom(room);
      setOpened(true);
    }
  };

  const createRoom = () => {
    setSelectedRoom(null);
    setOpened(true);
  };

  const deleteRoom = async (roomId) => {
    try {
      await axios.delete(
        `https://api.komorotel.com/api/rooms/${roomId}`,
        { withCredentials: true }
      );
    } catch (err) {
      console.error(err);
    }
    refreshData();
    setOpened(false);
  };

  const handleAvailabilitySuccess = async () => {
    try {
      // Vérifier si cette room a déjà des RatePrice
      const res = await axios.get(
        `https://api.komorotel.com/api/rateprices/room/${availabilityRoom._id}`,
        { withCredentials: true }
      );

      if (res.data.length === 0) {
        // Pas de tarif → aller sur tarifs + message
        setNeedRatePlanMsg?.(true);
        setActivePage("tarifs");
      } else {
        // Tarif existe → aller sur calendrier
        setActivePage("calendar");
      }

    } catch {
      // En cas d'erreur → tarifs par défaut
      setNeedRatePlanMsg?.(true);
      setActivePage("tarifs");
    }
  };

  return (
    <div style={{ padding: 30 }}>

      <h2 style={{ marginBottom: 30 }}>Chambres</h2>

      {loading ? (
        <RoomsSkeleton />
      ) : (
        <RoomsGrid
          rooms={data}
          openRoom={openRoom}
          openCreate={createRoom}
          deleteRoom={deleteRoom}
        />
      )}

      <RoomsDrawer
        open={opened}
        setOpen={setOpened}
        room={selectedRoom}
        refreshRooms={refreshData}
        hotelId={hotelId}
        setActivePage={setActivePage}
      />

      <AvailabilityDrawer
        open={availabilityOpen}
        setOpen={setAvailabilityOpen}
        room={availabilityRoom}
        refreshRooms={refreshData}
        onSuccess={handleAvailabilitySuccess}
      />

    </div>
  );
}